import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalRestoreContentVersion: ExperimentalMutations['experimentalRestoreContentVersion'] =
	(_, { contentId, versionNumber, message }, { network }) =>
		fetchJSON(network, `/wiki/rest/api/content/${contentId}/version`, {
			method: 'POST',
			headers: {
				Accept: MediaType.JSON,
				'Content-Type': MediaType.JSON,
			},
			body: JSON.stringify({
				operationKey: 'restore', //subject to change, documentation says "RESTORE"
				params: {
					versionNumber,
					message,
					restoreTitle: true,
				},
			}),
		}).then(
			/* onFulfilled */ () => ({
				restored: true,
				__typename: 'ExperimentalContentVersionRestored',
			}),
			/* onRejected */ () => ({
				restored: false,
				__typename: 'ExperimentalContentVersionRestored',
			}),
		);
